module.exports = __webpack_public_path__ + "img/lucrecia-silva-dias-byn.76b1e34a.jpg";